export enum IconButtonClass {
    Outlined = "cui-icon-button--outlined",
    Circular = "cui-icon-button-circular"
    //FIXME: Add contained styles when intended design for this has been implemented.
}
